<div layout="row" [ngClass]="styles.reportTabContentHeader">
	<h2 class="margin-0">{{ header }}</h2>
	<date-range-picker *ngIf="showDateFilter" #dateRangePicker class="margin-right-10 margin-left-auto" [defaultLabel]="'Reports_VideoReports_LastNDays' | translate : { '0' : 30 }" [dropdown]="true" [menuRight]="true" [maxDateRange]="365" [ngModel]="AnalyticsService.dateFilter$ | async" (ngModelChange)="onDateRangeChanged($event)">
	</date-range-picker>
</div>

<ng-content></ng-content>
